import React from 'react'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { BiX } from 'react-icons/bi'

// Confirmation dialog for deleting a folder. Deleting a folder is non-destructive
// to its contents — the items move back to the top level — so the copy makes that
// explicit. Clean, header-less layout matching FolderNameModal.
const FolderDeleteModal = ({
  open,
  folder,
  itemCount,
  itemNoun,
  parentLabel,
  onCancel,
  onConfirm,
}) => {
  if (!open || !folder) {
    return null
  }

  const count = itemCount || 0
  const noun =
    count === 1 && itemNoun ? itemNoun.replace(/s$/, '') : itemNoun || 'items'
  const destination =
    parentLabel && parentLabel !== 'Back' ? parentLabel : 'the top level'

  return (
    <Modal isOpen={open} centered>
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-start">
          <h5 className="folder-modal-title mb-0">Delete folder?</h5>
          <BiX
            className="cursor-pointer"
            color="#6c757d"
            size={26}
            onClick={() => onCancel()}
          />
        </div>
        <p className="folder-modal-subtitle mt-2 mb-0">
          <strong>"{folder.name}"</strong> will be deleted.
          {count > 0
            ? ` The ${count} ${noun} inside will be moved back to ${destination} — they won't be deleted.`
            : ''}
        </p>
      </ModalBody>
      <ModalFooter className="border-0 pt-0">
        <Button
          className="folder-btn-cancel"
          onClick={() => onCancel()}
        >
          Cancel
        </Button>
        <Button className="folder-delete-confirm-btn" onClick={() => onConfirm()}>
          Delete folder
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FolderDeleteModal
